import { jsxs as u, jsx as t } from "react/jsx-runtime";
import { GenericLink as b, Button as k, ButtonStyles as j, ButtonSize as C, NextgenImage as p, LoaderType as z, Theme as a } from "@nextgen-web-framework/all";
import { getCustomThemeColorClass as V, ThemeColor as x, ThemeColorClassTypes as g } from "./utils/themeColor.js";
import './assets/FeaturedCard.css';const y = "#ffffff", B = "#396e75", T = "#e5fdff", w = "#546223", N = "#f0fae5", $ = "#a65523", G = "#fff1e8", O = "#7f3e3e", R = "#ffe2e2", v = "#62625a", S = "#f8f8e7", L = "#38539a", E = "#707070", A = "#c8f8d1", W = "#87c9c8", Y = "#5291b1", D = "rgba(82, 145, 177, 0.1019607843)", I = "#445685", U = "#181d61", F = "rgba(24, 29, 97, 0.1019607843)", H = "#5969d6", K = "#ea999d", M = "#b6577e", q = "rgba(182, 87, 126, 0.1019607843)", J = "#7e3e80", Q = "#1e247f", X = "rgba(30, 36, 127, 0.1019607843)", Z = "#da7600", P = "#107f47", ee = "#d91734", re = "_html_ojtl9_75", r = {
  amwayWhite: y,
  darkBlue: B,
  lightBlue: T,
  darkGreen: w,
  lightGreen: N,
  darkOrange: $,
  lightOrange: G,
  darkRed: O,
  lightRed: R,
  darkYellow: v,
  lightYellow: S,
  darkPurple: L,
  darkGrayOnWhite: E,
  dataVizColor1: A,
  dataVizColor2: W,
  dataVizColor3: Y,
  dataVizColor3Background: D,
  dataVizColor4: I,
  dataVizColor5: U,
  dataVizColor5Background: F,
  dataVizColor6: H,
  dataVizColor7: K,
  dataVizColor8: M,
  dataVizColor8Background: q,
  dataVizColor9: J,
  dataVizColor10: Q,
  dataVizColor10Background: X,
  dataVizAlertOrange: Z,
  dataVizSuccessGreen: P,
  dataVizWarningRed: ee,
  "no-visible": "_no-visible_ojtl9_34",
  html: re,
  "theme-border-dark-red": "_theme-border-dark-red_ojtl9_283",
  "theme-border-dark-blue": "_theme-border-dark-blue_ojtl9_287",
  "theme-border-dark-orange": "_theme-border-dark-orange_ojtl9_291",
  "theme-border-dark-green": "_theme-border-dark-green_ojtl9_295",
  "theme-border-dark-purple": "_theme-border-dark-purple_ojtl9_299",
  "theme-border-dark-gray": "_theme-border-dark-gray_ojtl9_303",
  "theme-border-light-red": "_theme-border-light-red_ojtl9_307",
  "theme-border-light-blue": "_theme-border-light-blue_ojtl9_311",
  "theme-border-light-orange": "_theme-border-light-orange_ojtl9_315",
  "theme-border-light-green": "_theme-border-light-green_ojtl9_319",
  "theme-border-light-purple": "_theme-border-light-purple_ojtl9_323",
  "theme-border-light-gray": "_theme-border-light-gray_ojtl9_327",
  "theme-gradient-red": "_theme-gradient-red_ojtl9_331",
  "theme-gradient-blue": "_theme-gradient-blue_ojtl9_335",
  "theme-gradient-orange": "_theme-gradient-orange_ojtl9_339",
  "theme-gradient-green": "_theme-gradient-green_ojtl9_343",
  "theme-gradient-purple": "_theme-gradient-purple_ojtl9_347",
  "theme-dark-red-desc": "_theme-dark-red-desc_ojtl9_351",
  "theme-dark-blue-desc": "_theme-dark-blue-desc_ojtl9_355",
  "theme-dark-orange-desc": "_theme-dark-orange-desc_ojtl9_359",
  "theme-dark-green-desc": "_theme-dark-green-desc_ojtl9_363",
  "theme-dark-purple-desc": "_theme-dark-purple-desc_ojtl9_367",
  "theme-light-blue-desc": "_theme-light-blue-desc_ojtl9_371",
  "theme-light-red-desc": "_theme-light-red-desc_ojtl9_372",
  "theme-light-orange-desc": "_theme-light-orange-desc_ojtl9_373",
  "theme-light-green-desc": "_theme-light-green-desc_ojtl9_374",
  "theme-light-purple-desc": "_theme-light-purple-desc_ojtl9_375",
  "featured-container": "_featured-container_ojtl9_379",
  "featured-header-container": "_featured-header-container_ojtl9_379",
  "featured-header-title": "_featured-header-title_ojtl9_386",
  "featured-header-view-all": "_featured-header-view-all_ojtl9_393",
  "featured-card-container": "_featured-card-container_ojtl9_405",
  "featured-card": "_featured-card_ojtl9_405",
  "theme-dark-blue": "_theme-dark-blue_ojtl9_355",
  "theme-dark-green": "_theme-dark-green_ojtl9_363",
  "theme-dark-orange": "_theme-dark-orange_ojtl9_359",
  "theme-dark-red": "_theme-dark-red_ojtl9_351",
  "theme-dark-purple": "_theme-dark-purple_ojtl9_367",
  "theme-dark-gray": "_theme-dark-gray_ojtl9_442",
  "theme-light-blue": "_theme-light-blue_ojtl9_371",
  "theme-light-green": "_theme-light-green_ojtl9_374",
  "theme-light-orange": "_theme-light-orange_ojtl9_373",
  "theme-light-red": "_theme-light-red_ojtl9_372",
  "theme-light-purple": "_theme-light-purple_ojtl9_375",
  "theme-light-gray": "_theme-light-gray_ojtl9_466",
  "featured-card-text-container": "_featured-card-text-container_ojtl9_471",
  "featured-card-heading": "_featured-card-heading_ojtl9_480",
  "featured-card-heading-txtclr-dark_blue": "_featured-card-heading-txtclr-dark_blue_ojtl9_493",
  "featured-card-heading-txtclr-dark_green": "_featured-card-heading-txtclr-dark_green_ojtl9_496",
  "featured-card-heading-txtclr-dark_orange": "_featured-card-heading-txtclr-dark_orange_ojtl9_499",
  "featured-card-heading-txtclr-dark_red": "_featured-card-heading-txtclr-dark_red_ojtl9_502",
  "featured-card-desc": "_featured-card-desc_ojtl9_505",
  "featured-card-button": "_featured-card-button_ojtl9_517",
  "featured-card-desc-txtclr-dark_blue": "_featured-card-desc-txtclr-dark_blue_ojtl9_520",
  "featured-card-desc-txtclr-dark_green": "_featured-card-desc-txtclr-dark_green_ojtl9_523",
  "featured-card-desc-txtclr-dark_orange": "_featured-card-desc-txtclr-dark_orange_ojtl9_526",
  "featured-card-desc-txtclr-dark_red": "_featured-card-desc-txtclr-dark_red_ojtl9_529",
  "featured-card-image-container": "_featured-card-image-container_ojtl9_533",
  "featured-card-image": "_featured-card-image_ojtl9_533",
  "featured-card-border-dark_orange": "_featured-card-border-dark_orange_ojtl9_548",
  "featured-card-border-dark_blue": "_featured-card-border-dark_blue_ojtl9_552",
  "featured-card-border-dark_green": "_featured-card-border-dark_green_ojtl9_556",
  "featured-card-border-dark_red": "_featured-card-border-dark_red_ojtl9_560",
  "featured-card-border-light_gray": "_featured-card-border-light_gray_ojtl9_564",
  "card-bg-color-light_orange": "_card-bg-color-light_orange_ojtl9_568",
  "card-bg-color-white": "_card-bg-color-white_ojtl9_572",
  "card-bg-color-light_red": "_card-bg-color-light_red_ojtl9_576",
  "card-bg-color-light_blue": "_card-bg-color-light_blue_ojtl9_580",
  "card-bg-color-light_green": "_card-bg-color-light_green_ojtl9_584",
  "container-bg-color-light_orange": "_container-bg-color-light_orange_ojtl9_588",
  "container-bg-color-light_yellow": "_container-bg-color-light_yellow_ojtl9_592"
}, oe = (m) => {
  var h;
  const e = m, i = (h = e == null ? void 0 : e.image[0]) == null ? void 0 : h.image, s = e == null ? void 0 : e.image[0].alt_text, f = () => {
    switch (e.buttonBGColor) {
      case "dark_blue":
        return a.BLUE;
      case "dark_green":
        return a.GREEN;
      case "dark_orange":
        return a.ORANGE;
      case "dark_red":
        return a.RED;
      default:
        return a.ORANGE;
    }
  }, d = e.themeColor ? V(
    x[e.themeColor],
    e.themeShade
  ) : void 0;
  let o, l, _, c, n;
  return d ? (o = d[g.Base], l = "", _ = `${o}-desc`, c = d[g.Border], n = d[g.Button]) : (o = `card-bg-color-${e.backgroundColor ?? "white"}`, l = `featured-card-heading-txtclr-${e.headingColor}`, _ = `featured-card-desc-txtclr-${e.descColor}`, c = `featured-card-border-${e.borderColor ?? "light_gray"}`, n = f()), /* @__PURE__ */ u(
    "div",
    {
      className: `${r["featured-card"]} ${r[o]} ${r[c]}`,
      "data-testid": "featured-card-test-id",
      "data-pod-name": "commerce",
      children: [
        /* @__PURE__ */ u("div", { className: r["featured-card-text-container"], children: [
          /* @__PURE__ */ t("h4", { className: `${r["featured-card-heading"]} ${r[l]}`, children: e.heading }),
          /* @__PURE__ */ t("div", { className: `${r["featured-card-desc"]} ${r[_]}`, children: e.description }),
          !!e.buttonURL && /* @__PURE__ */ t("div", { className: `${r["featured-card-button"]}`, children: /* @__PURE__ */ t(b, { href: e.buttonURL, forceNative: !1, target: e.buttonTarget, children: /* @__PURE__ */ t(
            k,
            {
              title: e.buttonText,
              buttonStyle: j.SOLID,
              theme: n,
              size: C.SMALL,
              "data-testid": "learn_more_button",
              "data-pod-name": "commerce"
            }
          ) }) })
        ] }),
        /* @__PURE__ */ t("div", { className: r["featured-card-image-container"], children: /* @__PURE__ */ t(
          p,
          {
            className: r["featured-card-image"],
            src: i.url,
            alt: s,
            loaderType: z.CONTENTSTACK
          },
          `${i.title}`
        ) })
      ]
    }
  );
};
export {
  oe as F,
  r as s
};
//# sourceMappingURL=FeaturedCard-6fb12092.mjs.map
